import { FormElementMembershipLevelType } from './form-element-membership-level-type.model';
import { FormElement } from '../form-element.model';

export class FormElementMembershipLevel extends FormElement {
  MembershipLevelOptions: FormElementMembershipLevelType[];
  public constructor() {
    super();
    this.MembershipLevelOptions = [];
    this.ElementTypeId = 16;
  }
}
